const filterContainer = document.querySelector('.archive-item-filter');
const filterForm = document.querySelector('.items-filter__filter-posts-form');
if (filterContainer) {
    //Si le viewport est < 768px on ajoute un evenement sur la classe items-filter__title lorsqu'on clique dessus on ajoute la classe is-open à l'élément qui a la classe items-filter__mobile-dropdown
    const filterTitle = document.querySelector('.items-filter__title');
    if (window.innerWidth < 768 && filterTitle) {
        const filterTitleArrow = document.querySelector('.items-filter__title-arrow');
        filterTitle.addEventListener('click', (e) => {
            e.preventDefault();
            filterTitle.classList.toggle('is-open');
            filterTitleArrow.classList.toggle('is-open');
            filterContainer.querySelector('.items-filter__mobile-dropdown').classList.toggle('is-open');

        })
    }

    // Nouveau gabarit des listings (template-parts/listing/filters.php)
    const isListing = filterContainer.classList.contains('frge-listing-filters');

    // Listes déroulantes du nouveau gabarit : état annoncé aux lecteurs d'écran
    const syncDropdowns = () => {
        if (!isListing) return;
        filterContainer.querySelectorAll('.items-filter__dropdown-container__top').forEach((top) => {
            const choices = top.parentElement.querySelector('.items-filter__dropdown-choices');
            top.setAttribute('aria-expanded', choices.classList.contains('is-open') ? 'true' : 'false');
        });
    };

    // Choix sélectionnés : état des pastilles et libellé des listes déroulantes
    const syncChoices = () => {
        if (!isListing) return;
        filterContainer.querySelectorAll('.items-filter__dropdown-choices > span').forEach((choice) => {
            choice.setAttribute('aria-pressed', choice.classList.contains('is-selected') ? 'true' : 'false');
        });
        filterContainer.querySelectorAll('.frge-listing-filters__select-value').forEach((value) => {
            const selected = value.closest('.items-filter__dropdown-container').querySelectorAll('.items-filter__dropdown-choices > span.is-selected');
            value.textContent = selected.length ? [...selected].map((choice) => choice.textContent.trim()).join(', ') : value.dataset.all;
        });
    };

    // Ordinateur : position collante de la colonne et place disponible pour les listes déroulantes
    const desktopListing = window.matchMedia('(min-width: 1024px)');
    const stickyMetrics = () => {
        const root = getComputedStyle(document.documentElement);
        const rem = parseFloat(root.fontSize);
        const adminBar = document.body.classList.contains('admin-bar') ? 32 : 0;
        const base = parseFloat(root.getPropertyValue('--header-height')) * rem + 1.5 * rem + adminBar;
        // Colonne plus haute que l'écran : elle remonte d'autant pour montrer son dernier champ
        const overflow = Math.max(0, base + filterContainer.offsetHeight + 1.5 * rem - window.innerHeight);
        return { rem, base, overflow };
    };
    const setStickyTop = () => {
        if (!isListing) return;
        if (!desktopListing.matches) {
            filterContainer.style.removeProperty('--frge-listing-filters-overflow');
            return;
        }
        filterContainer.style.setProperty('--frge-listing-filters-overflow', `${stickyMetrics().overflow}px`);
    };
    // Liste ouverte : hauteur limitée à l'écran, ouverture vers le haut si la place manque dessous
    const fitDropdown = (choices) => {
        if (!isListing) return;
        choices.style.removeProperty('max-height');
        choices.classList.remove('is-above');
        if (!desktopListing.matches || !choices.classList.contains('is-open')) return;
        const { rem, base, overflow } = stickyMetrics();
        const top = choices.parentElement.querySelector('.items-filter__dropdown-container__top');
        const asideTop = filterContainer.getBoundingClientRect().top;
        const stuckTop = base - overflow;
        const below = window.innerHeight - (stuckTop + top.getBoundingClientRect().bottom - asideTop) - 1.5 * rem;
        const above = stuckTop + choices.parentElement.getBoundingClientRect().top - asideTop - base + rem;
        const useAbove = below < 10 * rem && above > below;
        choices.classList.toggle('is-above', useAbove);
        choices.style.maxHeight = `${Math.min(20 * rem, Math.max(8 * rem, useAbove ? above : below))}px`;
    };

    if (isListing) {
        setStickyTop();
        window.addEventListener('resize', setStickyTop);
        if ('ResizeObserver' in window) {
            new ResizeObserver(setStickyTop).observe(filterContainer);
        }

        // Entrée dans le champ de recherche : pas d'envoi du formulaire vers admin-ajax
        filterForm.addEventListener('submit', (e) => e.preventDefault());

        // Archives de taxonomie et recherche : les clics sont traités par archive-taxo-filters.js, l'affichage est resynchronisé ici
        if (document.querySelector('.archive-main').classList.contains('is-taxo-archive')) {
            filterContainer.addEventListener('click', (e) => {
                if (e.target.closest('.items-filter__dropdown-choices > span')) {
                    syncChoices();
                }
            });
        }

        // Pastilles et options au clavier
        filterContainer.addEventListener('keydown', (e) => {
            if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('.items-filter__dropdown-choices > span')) {
                e.preventDefault();
                e.target.click();
            }
        });

        // Mobile : le formulaire s'ouvre en panneau
        const moreButton = filterContainer.querySelector('.frge-listing-filters__more');
        const closeButton = filterContainer.querySelector('.frge-listing-filters__close');
        const backdrop = filterContainer.querySelector('.frge-listing-filters__backdrop');
        const setPanel = (open) => {
            filterContainer.classList.toggle('is-open', open);
            document.body.classList.toggle('frge-listing-filters-open', open);
            document.body.classList.toggle('no-scroll', open);
            moreButton.setAttribute('aria-expanded', open ? 'true' : 'false');
            backdrop.hidden = !open;
            if (open) {
                filterForm.setAttribute('data-lenis-prevent', '');
                closeButton.focus();
            } else {
                filterForm.removeAttribute('data-lenis-prevent');
                moreButton.focus();
            }
        };
        // Fondu haut/bas du panneau quand il reste des filtres à faire défiler (comme le menu)
        let fadeTicking = false;
        const updatePanelFade = () => {
            fadeTicking = false;
            if (!filterContainer.classList.contains('is-open')) return;
            const maxScroll = filterForm.scrollHeight - filterForm.clientHeight;
            filterForm.classList.toggle('has-more-above', filterForm.scrollTop > 1);
            filterForm.classList.toggle('has-more-below', maxScroll - filterForm.scrollTop > 1);
        };
        const requestPanelFade = () => {
            if (!fadeTicking) {
                fadeTicking = true;
                window.requestAnimationFrame(updatePanelFade);
            }
        };
        filterForm.addEventListener('scroll', requestPanelFade, { passive: true });
        if ('ResizeObserver' in window) {
            const fadeObserver = new ResizeObserver(requestPanelFade);
            fadeObserver.observe(filterForm);
            [...filterForm.children].forEach((child) => fadeObserver.observe(child));
        } else {
            window.addEventListener('resize', requestPanelFade);
        }

        moreButton.addEventListener('click', () => {
            setPanel(true);
            updatePanelFade();
        });
        closeButton.addEventListener('click', () => setPanel(false));
        backdrop.addEventListener('click', () => setPanel(false));
        // « Valider » : les filtres s'appliquent déjà au clic, le bouton referme le panneau
        filterContainer.querySelector('.frge-listing-filters__submit-button')?.addEventListener('click', () => setPanel(false));
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && filterContainer.classList.contains('is-open')) {
                setPanel(false);
            }
        });
        // Passage en disposition ordinateur panneau ouvert : on le referme
        window.matchMedia('(min-width: 1024px)').addEventListener('change', (e) => {
            if (e.matches && filterContainer.classList.contains('is-open')) {
                setPanel(false);
            }
        });
    }


    //Dropdown des filtres
    const filtersTopContainer = document.querySelectorAll('.items-filter__dropdown-container__top');
    filtersTopContainer.forEach((filterTopContainer) => {
        filterTopContainer.addEventListener('click', (e) => {
            //On ferme tous les autres dropdowns sauf celui qui a été cliqué
            const otherDropDowns = document.querySelectorAll('.items-filter__dropdown-choices.is-open');
            otherDropDowns.forEach((dropDown) => {
                if (dropDown !== filterTopContainer.parentElement.querySelector('.items-filter__dropdown-choices')) {
                    dropDown.classList.remove('is-open');
                    //On selectionne le parent puis l'icon pour changer la direction de la flèche
                    dropDown.parentElement.querySelector('.items-filter__dropdown-container__icon').classList.remove('is-open');
                }
            })
            e.preventDefault();
            const dropDownChoices = filterTopContainer.parentElement.querySelector('.items-filter__dropdown-choices')
            dropDownChoices.parentElement.querySelector('.items-filter__dropdown-container__icon').classList.toggle('is-open');
            dropDownChoices.classList.toggle('is-open');
            fitDropdown(dropDownChoices);
            syncDropdowns();
        })
    });

    //If it's a taxonomy archive we don't use this script view archive-taxo-filters.js
    const isTaxoArchive = document.querySelector('.archive-main').classList.contains('is-taxo-archive');
    (function ($) {
        $(document).ready(function () {
            //Quand le top du container #items-filter atteint le top du viewport on lui ajoute la classe is-fixed
            let itemsFilter = $('#items-filter');
            let itemsFilterTop = itemsFilter.length ? itemsFilter.offset().top : 0;
            let headerHeight = $('.header__top').outerHeight();

            // I-1 (CLS) : la barre est rendue « collante » par le CSS
            // (#items-filter { position: sticky; top: var(--header-height) }) qui réserve sa
            // place dans le flux en permanence -> zéro layout shift. On ne bascule plus AUCUNE
            // propriété de layout au scroll (fini le padding-top sur #items-wrapper, le
            // position:fixed et le margin-bottom). On n'ajoute qu'une classe d'état purement
            // visuelle (ombre = paint/composite) quand la barre est collée sous le header.
            let isStuck = false;
            $(window).scroll(function () {
                if (!itemsFilter.length) return;
                const shouldStick = $(window).scrollTop() >= itemsFilterTop - headerHeight;
                if (shouldStick !== isStuck) {
                    isStuck = shouldStick;
                    itemsFilter.toggleClass('is-fixed', shouldStick);
                }
            });


            $(document).click(function (e) {
                if (!$(e.target).closest('.items-filter__dropdown-container').length) {
                    $('.items-filter__dropdown-choices').removeClass('is-open');
                    $('.items-filter__dropdown-container__icon').removeClass('is-open');
                    syncDropdowns();
                }
            });

            if (!isTaxoArchive) {
                const notFoundContainer = $('.not-found').clone();
                $('.not-found').remove();
                let values = {
                    category: ['*'],
                    post_tag: ['*'],
                    frge_profile: ['*'],
                    frge_podcast_categories: ['*'],
                };
                let searchTerm = '';

                let nonce = $(filterForm).find('input[name="nonce"]').val();
                let action = $(filterForm).find('input[name="action"]').val();
                let ajaxUrl = $(filterForm).attr('action');
                let postType = $('.archive-main').attr('data-post-type');
                currentPage = 1;

                const crossIcon = '<svg stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="items-filter__cross-icon"><path d="M9.17218 14.8284L12.0006 12M14.829 9.17157L12.0006 12M12.0006 12L9.17218 9.17157M12.0006 12L14.829 14.8284" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

                // Liste déjà rendue côté serveur (articles, index.php) : pas d'AJAX au chargement
                const serverRendered = $('#items-wrapper').children().length > 0;

                // Archive catégorie : filtre « Catégorie » présélectionné
                const presetCategory = $('.archive-main').attr('data-category');
                if (presetCategory) {
                    values.category = [presetCategory];
                    $('.items-filter__dropdown-choices > span[data-name="category"][data-value="' + presetCategory + '"]').addClass('is-selected').prepend(crossIcon);
                }
                const initialState = JSON.stringify(values);
                syncChoices();

                // Changement de page en AJAX : retour en haut de page (en haut de la liste sur le nouveau gabarit)
                function scrollToResults() {
                    const body = isListing ? document.querySelector('.frge-listing__body') : null;
                    const top = body ? Math.max(0, $(body).offset().top - $('.header__top').outerHeight()) : 0;
                    $('html, body').animate({ scrollTop: top }, 500);
                }

                // Retour à l'état initial sur une page rendue côté serveur : on recharge l'URL courante
                function refreshPosts() {
                    if (serverRendered && JSON.stringify(values) === initialState && searchTerm === '') {
                        window.location.reload();
                        return;
                    }
                    fetchPosts(ajaxUrl, values, nonce, action, postType);
                }
                //On ajoute un evenement pour fermer les dropdowns lorsqu'on clique en dehors


                //On ajoute un evenement sur les span pour ajouter la classe is-selected et ajouter la valeur de l'attribut data-value dans le tableau values
                $('.items-filter__dropdown-choices > span').click(function () {

                    let taxoVal = $(this).attr('data-value');
                    let taxoName = $(this).attr('data-name');


                    ajaxUrl = $(filterForm).attr('action');

                    if (taxoVal === '*') {
                        values[taxoName] = ['*'];
                        $(this).parent().find('span').removeClass('is-selected');
                        $(this).addClass('is-selected');
                    } else {
                        values[taxoName] = values[taxoName].filter((item) => item !== '*');
                    }
                    //Si la taxoVal est déjà dans le tableau, on l'enlève l'objet correspondant du tableau sinon on l'ajoute
                    if (values[taxoName].includes(taxoVal)) {
                        values[taxoName] = values[taxoName].filter((item) => item !== taxoVal);
                    }
                    else {
                        if (postType === 'frge_documents' && taxoName === 'category') {
                            values[taxoName] = [];
                            $(this).parent().find('span').removeClass('is-selected');
                            $(this).parent().find('svg').remove();
                        }
                        values[taxoName].push(taxoVal);

                    }

                    if (values[taxoName].length === 0) {
                        values[taxoName].push('*');
                    }

                    //ON fait une requête fetch pour récupérer les posts correspondants aux filtres
                    currentPage = 1;
                    refreshPosts();
                    //On ajoute la classe active à l'élément qui a data-page=currentpage
                    $(this).toggleClass('is-selected');
                    if ($(this).hasClass('is-selected')) {
                        $(this).prepend(crossIcon);
                    }
                    else {
                        $(this).find('svg').remove();
                    }
                    syncChoices();

                })

                // Nouveau gabarit : chevrons de la maquette, fournis par #pagination[data-icon-prev|next]
                function paginationIcon(direction) {
                    const src = $('#pagination').attr('data-icon-' + direction);
                    return src ? $('<img>').attr({ src: src, alt: '', width: 24, height: 24 }) : '';
                }

                function createPagination(maxPages) {
                    let pagination = $('#pagination');
                    pagination.html('');
                    let paginationList = $('<ul>').addClass('pagination__list');
                    pagination.append(paginationList);

                    let displayPages = maxPages;
                    if (displayPages > 6) {
                        displayPages = 6;
                    }

                    let startPage = 1;
                    if (currentPage > 6) {
                        startPage = currentPage - 1;
                    }

                    if (currentPage > maxPages - 5 && maxPages - 5 > 0) {
                        startPage = maxPages - 5;
                    }

                    for (let i = startPage; i <= maxPages && i < startPage + 6; i++) {
                        let paginationItem = $('<li>').addClass('pagination__item');
                        paginationItem.attr('data-page', i);
                        paginationList.append(paginationItem);
                        let paginationLink = $('<a>').addClass('pagination__link')
                            .attr('href', '#')
                            .text(i);
                        paginationItem.append(paginationLink);

                        if (i === currentPage) {
                            paginationItem.addClass('active');
                        }

                        $(paginationItem).click(function (e) {
                            e.preventDefault();
                            let page = $(this).attr('data-page');
                            ajaxUrl = $(filterForm).attr('action');
                            ajaxUrl = ajaxUrl + '?page=' + page;
                            currentPage = page;
                            //Scroll to top
                            scrollToResults();
                            fetchPosts(ajaxUrl, values, nonce, action, postType);
                        });
                    }

                    if (startPage + 5 < maxPages && maxPages > 6) {
                        let paginationItem = $('<li>').addClass('pagination__item');
                        paginationList.append(paginationItem);
                        let paginationLink = $('<span>').addClass('pagination__link')
                            .text('...');
                        paginationItem.append(paginationLink);
                        let paginationItemLast = $('<li>').addClass('pagination__item pagination__item--edge');
                        paginationItemLast.attr('data-page', maxPages);
                        paginationList.append(paginationItemLast);
                        let paginationLinkLast = $('<a>').addClass('pagination__link')
                            .attr('href', '#')
                            .text(maxPages);
                        paginationItemLast.append(paginationLinkLast);
                        paginationItemLast.click(function (e) {
                            e.preventDefault();
                            let page = $(this).attr('data-page');
                            ajaxUrl = $(filterForm).attr('action');
                            ajaxUrl = ajaxUrl + '?page=' + page;
                            currentPage = page;
                            scrollToResults();

                            fetchPosts(ajaxUrl, values, nonce, action, postType);
                        });
                    } else if (maxPages > 6) {
                        let paginationItem = $('<li>').addClass('pagination__item');
                        paginationList.prepend(paginationItem);
                        let paginationLink = $('<span>').addClass('pagination__link')
                            .text('...');
                        paginationItem.append(paginationLink);
                        let paginationItemFirst = $('<li>').addClass('pagination__item pagination__item--edge');
                        paginationItemFirst.attr('data-page', 1);
                        paginationList.prepend(paginationItemFirst);
                        let paginationLinkFirst = $('<a>').addClass('pagination__link')
                            .attr('href', '#')
                            .text(1);
                        paginationItemFirst.append(paginationLinkFirst);
                        paginationItemFirst.click(function (e) {
                            e.preventDefault();
                            let page = $(this).attr('data-page');
                            ajaxUrl = $(filterForm).attr('action');
                            ajaxUrl = ajaxUrl + '?page=' + page;
                            currentPage = page;
                            scrollToResults();

                            fetchPosts(ajaxUrl, values, nonce, action, postType);
                        });
                    }

                    //Prev arrow
                    let prevItem = $('<li>').addClass('pagination__item__prev');
                    let prevLink = $('<a>').addClass('pagination__link__prev')
                        .attr('href', '#')
                        .html(paginationIcon('prev') || '<svg width="24px" height="24px" stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="#000000"><path d="M15 6L9 12L15 18" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>')
                    if (parseInt(currentPage) === 1) {
                        prevItem.addClass('disabled');
                    } else {
                        prevLink.attr('data-page', parseInt(currentPage) - 1);
                        prevLink.on('click', function (e) {
                            e.preventDefault();
                            let page = $(this).attr('data-page');
                            ajaxUrl = $(filterForm).attr('action');
                            ajaxUrl = ajaxUrl + '?page=' + page;
                            currentPage = page;
                            scrollToResults();

                            fetchPosts(ajaxUrl, values, nonce, action, postType);
                        });
                    }

                    if (isListing) {
                        prevLink.attr('aria-label', $('#pagination').attr('data-label-prev'));
                    }
                    prevItem.append(prevLink);
                    paginationList.prepend(prevItem);
                    // Flèche "Suivant"
                    let nextItem = $('<li>').addClass('pagination__item__next');
                    let nextLink = $('<a>').addClass('pagination__link__next')
                        .attr('href', '#')
                        .html(paginationIcon('next') || '<svg width="24px" height="24px" stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="#000000"><path d="M9 6L15 12L9 18" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>');
                    if (parseInt(currentPage) != maxPages) {
                        nextLink.attr('data-page', parseInt(currentPage) + 1);
                        nextLink.on('click', function (e) {
                            e.preventDefault();
                            let page = $(this).attr('data-page');
                            ajaxUrl = $(filterForm).attr('action');
                            ajaxUrl = ajaxUrl + '?page=' + page;
                            currentPage = page;
                            scrollToResults();

                            fetchPosts(ajaxUrl, values, nonce, action, postType);
                        });
                    } else {
                        nextItem.addClass('disabled');
                    }
                    if (isListing) {
                        nextLink.attr('aria-label', $('#pagination').attr('data-label-next'));
                    }
                    nextItem.append(nextLink);
                    paginationList.append(nextItem);
                }

                function fetchPosts(url, values, nonce, action, postType) {
                    $('.loader').css('display', 'flex');
                    fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        body: new URLSearchParams({
                            'action': action,
                            'nonce': nonce,
                            'values': JSON.stringify(values),
                            'post_type': postType,
                            'search': searchTerm,
                        })
                    })
                        .then(response => response.json())
                        .then(data => {
                            $('.loader').css('display', 'none');
                            if (data.data.html != '') {
                                if (notFoundContainer) {
                                    notFoundContainer.hide();
                                }
                                $('#items-wrapper').html(data.data.html);
                                createPagination(data.data.max_num_pages);
                                $('.pagination__item[data-page="' + currentPage + '"]').addClass('is-active');
                            } else {
                                if (notFoundContainer && $('#items-wrapper').find('.not-found').length === 0) {
                                    notFoundContainer.show();
                                    $('#items-wrapper').html(notFoundContainer);
                                }
                                $('#pagination').html('');
                            }
                        })
                        .catch((error) => {
                            console.error('Error:', error);
                        });
                }

                //Recherche par mot-clé (titre / contenu) avec un léger debounce
                const searchInput = document.querySelector('.items-filter__search-input');
                if (searchInput) {
                    let searchDebounce;
                    searchInput.addEventListener('input', function () {
                        clearTimeout(searchDebounce);
                        searchDebounce = setTimeout(function () {
                            searchTerm = searchInput.value.trim();
                            currentPage = 1;
                            ajaxUrl = $(filterForm).attr('action');
                            refreshPosts();
                        }, 300);
                    });
                }

                if (!serverRendered) {
                    fetchPosts(ajaxUrl, values, nonce, action, postType);
                }
            }

        });




    })(jQuery)
}